module.exports = __webpack_public_path__ + "img/city.01545c44.png";